import { Injectable } from '@angular/core';
import {
  Action,
  AngularFirestore,
  AngularFirestoreCollection,
  DocumentChangeAction,
  DocumentReference,
  DocumentSnapshot,
} from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Quiniela } from '../models/quiniela';

@Injectable({
  providedIn: 'root'
})
export class QuinielasService {
  private quinielaCollection: AngularFirestoreCollection<Quiniela>;

  constructor(private db: AngularFirestore) {
    this.quinielaCollection = this.db.collection<Quiniela>('quinielas');
  }

  /**
   * GET ALL QUINIELAS
   */
  getAllQuinielas(): Observable<DocumentChangeAction<Quiniela>[]> {
    return this.quinielaCollection.snapshotChanges();
  }

  /**
   * GET QUINIELA BY ID
   * @param quinielaId
   */
  getQuiniela(quinielaId: string): Observable<Action<DocumentSnapshot<Quiniela>>> {
    return this.quinielaCollection.doc<Quiniela>(quinielaId).snapshotChanges();
  }

  /**
   * CREATE NEW QUINIELA
   * @param newQuiniela
   */
  createQuiniela(newQuiniela: Quiniela): Promise<DocumentReference> {
    return this.quinielaCollection.add(newQuiniela);
  }

  /**
   * UPDATE SELECTED QUINIELA
   * @param data
   * @param docId
   */
  updateQuiniela(data: Quiniela, docId: string): Promise<void> {
    return this.quinielaCollection.doc<Quiniela>(docId).update(data);
  }

  /**
   * DELETE QUINIELA
   * @param docId
   */
  deleteQuiniela(docId: string): Promise<void> {
    return this.quinielaCollection.doc<Quiniela>(docId).delete();
  }

  /**
 * GET ALL QUINIELAS DE UN USUARIO
 */
  public getAllQuinielasDeUnUsuario(user: string): Observable<DocumentChangeAction<any>[]> {
    var query = this.db.collection('quinielas', (ref) =>
      ref.where('user', '==', user)
    );
    return query.snapshotChanges()
  }

  /**
* GET QUINIELA CON EL URL
*/
  public getQuinielaByURL(url: string): Observable<DocumentChangeAction<any>[]> {
    var query = this.db.collection('quinielas', (ref) =>
      ref.where('url', '==', url)
    );
    return query.snapshotChanges();
  }

}
